const projectName = Symbol('projectName');
const businessId = Symbol('businessId');
const middle = Symbol('middle');
class AcstaticDunAntiCheating {
  constructor(option = {}) {
    const { auto = false } = option;
    this.acstaticDunScript = undefined;
    this.acstaticDunSSRConfig = {};
    //  获取 token 的超时时间，单位是秒
    this.timeout = 5;
    /**
    * 17 时间格式到分，19 到秒, 23 到毫秒，以年月日时分秒毫秒格式
    * @param { 17 } timeLength
    */
   this.getCurrentTime = (timeLength = 23) => (date => new Date(date - date.getTimezoneOffset() * 6e4).toJSON().substr(0, timeLength).replace('T', ' '))(new Date()).replace(/[\-\s\:\.Z]/g, '')
    try {
      //  将后端渲染的东西序列化成对象
      this.acstaticDunSSRConfig = typeof window.ssrConfig !== 'string' && window.ssrConfig.routerConfig || JSON.parse(decodeURIComponent(window.ssrConfig)).routerConfig;
    } catch (err) {}
    this[projectName] = this.acstaticDunSSRConfig?.acstaticDun?.productNumber ?? 'YD00481894759076';
    this[businessId] = this.acstaticDunSSRConfig?.acstaticDun?.businessId ?? '1f79adf09c1f46b1831eb484b4a2306d';
    this.auto = !!auto;
    this.vm = undefined;
    //  token 状态枚举
    this.tokenEnum = {
      pending: 1,
      used: 2
    }
    //  当前 token
    this.currentToken = {
      value: '',
      loadTime: undefined,
      status: this.tokenEnum.used
    };
    this[middle] = this.acstaticDunSSRConfig?.acstaticDun?.middle ?? [
      //  下单
      'shop/order/v2/save',
      //  支付
      'shop/pay/submit',
      //  发送登录短信验证码
      'operator/login/sendLoginSms.do',
      //  短信登录
      'operator/login/smsLogin.do',
      //  发送第三方的登录短信验证码
      'operator/register/sendRegisterSms.do',
      //  注册并绑定接口
      'operator/register/bind.do',
      //  激活并绑定接口
      'operator/register/active/bind.do',
      //  授权登陆
      'operator/login/authLogin.do',
      //  微信绑定手机号
      'operator/register/bindLoginName.do',
      //  H5 浏览器助力进入，绑定或注册接口
      'operator/register/wechatRegisterAndBind.do'
    ];
  }
  /**
   * 获取的 token 保证是新鲜的
   */
  get token() {
    return new Promise((resolve, reject) => {
      if (!this.vm) {
        this.loadScript().then(() => {
          this.goGetToken().then(resolve).catch(reject);
        }).catch(reject);
      } else if (this.currentToken.status === this.tokenEnum.used) {
        this.goGetToken().then(resolve).catch(reject);
      } else {
        resolve(this.currentToken);
      }
    });
  }
  /**
   * 金盾反作弊过滤器
   */
  checkAcstaticDunAntiCheating(url) {
    return new Promise((resolve, reject) => {
      const isMiddle = this[middle].filter(e => url.indexOf(e) !== -1).length;
      if (!isMiddle) {
        resolve({
          isAntiCheating: false,
          token: ''
        });
        return;
      }
      //  开始获取 token
      const timeoutStatus = {
        status: 1
      };
      const __timeout = setTimeout(() => {
        clearTimeout(__timeout);
        if (timeoutStatus.status === 1) {
          timeoutStatus.status = 0;
          resolve({
            isAntiCheating: false,
            token: ''
          });
        }
      }, this.timeout * 1000);
      this.token.then(() => {
        if (timeoutStatus.status === 1) {
          timeoutStatus.status = 0;
          resolve({
            isAntiCheating: true,
            token: this.currentToken
          })
        }
      }).catch(() => {
        resolve({
          isAntiCheating: false,
          token: ''
        });
      });
    });
  }
  /**
   * 获取 token
   */
  goGetToken() {
    return new Promise((resolve, reject) => {
      this.vm.start();
      this.vm.getToken(this[businessId], token => {
        this.currentToken.value = token;
        this.currentToken.loadTime = this.getCurrentTime(23);
        this.currentToken.status = this.tokenEnum.pending;
        resolve(this.currentToken);
      }, reject);
    }).finally(() => this.vm.stop());
  }
  /**
   * 设置 token 过期
   */
  setTokenUsed() {
    this.currentToken.status = this.tokenEnum.used;
  }
  /**
   * 加载反作弊 script
   */
  loadScript() {
    return new Promise((resolve, reject) => {
      try {
        this.acstaticDunScript && this.acstaticDunScript.remove();
        this.acstaticDunScript = undefined;
        this.acstaticDunScript = document.createElement('script');
        this.acstaticDunScript.src = '//acstatic-dun.126.net/tool.min.js?t=' + this.getCurrentTime(17);
        this.acstaticDunScript.onload = () => {
          const __timeout = setTimeout(() => {
            try {
              clearTimeout(__timeout);
              this.vm = undefined;
              // 只需初始化一次
              initWatchman({
                productNumber: this[projectName],
                protocol: window.location.protocol,
                auto: this.auto,
                onload: instance => {
                  try {
                    this.vm = instance;
                    resolve();
                  } catch(onloadError) {
                    reject(onloadError);
                  }
                },
                onerror: reject
              });
            } catch (callbackError) {
              debugger
              reject(callbackError);
            }
          }, 10);
          this.acstaticDunScript.onerror = reject;
        };
        document.head.appendChild(this.acstaticDunScript);
      } catch(err) {
        reject(err);
      }
    })
  }
}
export default AcstaticDunAntiCheating
